(() => {
  const backToTop = document.querySelector('[data-back-to-top]');
  if (!backToTop) return;

  const scrollTop = Number(backToTop.dataset.scrollTop) || 100;

  const updateState = () => {
    backToTop.classList.toggle('is--show', window.scrollY > scrollTop);
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollableHeight > 0 ? (window.scrollY / scrollableHeight) * 100 : 0;
    backToTop.style.setProperty('--back-to-top-progress', `${Math.min(progress, 100)}%`);
  };

  backToTop.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.addEventListener('scroll', updateState, { passive: true });
  updateState();
})();
